import React from 'react'
import ChangePassword from '../../components/change-password/ChangePassword'

export default function ChangePasswordPage() {
  return (
    <div>
        <ChangePassword/>
    </div>
  )
}
